import * as React from 'react'
import styled from 'styled-components'
import { mobileBreakPoint } from 'app.styled/media'

const NewsCardItemLoading: React.FC = () => {
  return (
    <StyledWrapper>
      <div className="lt">
        <div className="img"></div>
        <div className="content">
          <div className="channel-name"></div>
          <div className="channel-content"></div>
          <div className="channel-desc"></div>
        </div>
      </div>
      <div className="rt"></div>
    </StyledWrapper>
  )
}

export default NewsCardItemLoading

const StyledWrapper = styled.div`
  padding: 20px 0;
  display: flex;
  justify-content: space-between;
  border-bottom: 1px solid #eeeeee;
  align-items: center;
  > .lt {
    display: flex;
    gap: 28px;
    overflow: hidden;
    .img {
      width: 66px;
      height: 66px;
      border-radius: 5px;
      background-color: #eeeeee;
    }
    .content {
      overflow: hidden;
      .channel-name {
        height: 12px;
        width: 70px;
        border-radius: 5px;
        background-color: #eeeeee;
        margin-bottom: 4px;
      }
      .channel-content {
        height: 16px;
        width: 200px;
        border-radius: 5px;
        background-color: #eeeeee;
        margin-bottom: 8px;
      }
      .channel-desc {
        height: 12px;
        width: 100px;
        border-radius: 5px;
        background-color: #eeeeee;
      }
    }
  }
  > .rt {
    padding: 20px;
  }
  ${mobileBreakPoint} {
    > .lt {
      padding-left: 20px;
      gap: 10px;
    }
  }
`
